import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { CHANGE_LOG_ENTRIES } from "@/components/changeLogEntries";

const RECENT_CHANGE_LOG_ENTRIES = CHANGE_LOG_ENTRIES.slice(0, 3);

type UpdateAnnouncementDialogProps = {
  open: boolean;
  onClose: () => void;
};

const UpdateAnnouncementDialog = ({ open, onClose }: UpdateAnnouncementDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Novinky v Energovizoru</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={3}>
          <Typography variant="body1" color="text.secondary">
            Připravili jsme pro Vás přehled posledních důležitých změn a nových funkcí.
          </Typography>

          {RECENT_CHANGE_LOG_ENTRIES.map((entry) => (
            <Stack key={`${entry.date}-${entry.title}`} spacing={1.25}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1.5}
                alignItems={{ xs: "flex-start", sm: "center" }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    px: 1.2,
                    py: 0.5,
                    borderRadius: 10,
                    bgcolor: "#8FA93A",
                    color: (theme) => theme.palette.mode === "dark" ? theme.palette.primary.contrastText : "white",
                    fontWeight: 700,
                    letterSpacing: "0.02em",
                  }}
                >
                  {entry.date}
                </Typography>
                <Typography variant="subtitle1" fontWeight={700}>
                  {entry.title}
                </Typography>
              </Stack>

              <Stack spacing={0.75}>
                {entry.changes.map((change) => (
                  <Typography key={change} variant="body2" color="text.secondary">
                    {"• "}
                    {change}
                  </Typography>
                ))}
              </Stack>
            </Stack>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Rozumím
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateAnnouncementDialog;
